<script setup lang="ts">
import { formatCurrency } from "shared/helpers";

import type { ShopInteractiveProductResponseDto } from "~/common/interfaces/dto/shop/shop-interactive-product-response.dto";

const shopStore = useShopStore();

const productIdMapping = [
	{
		id: 3,
		placement: "right",
		classes: "right-[35%] top-[38%]",
		link: "/shop/toppers/3"
	},
	{
		id: 4,
		placement: "right",
		classes: "left-[10%] top-[27%]",
		link: "/shop/toppers/4"
	},
	{
		id: 5,
		placement: "left",
		classes: "right-[20%] bottom-[20%]",
		link: "/shop/other/5"
	},
	{
		id: 7,
		placement: "right",
		classes: "left-[42.3%] bottom-[25%]",
		link: "/shop/toppers/7"
	},
	{
		id: 9,
		placement: "left",
		classes: "right-[15%] top-[38%]",
		link: "/shop/candles/9"
	},
	{
		id: 9,
		placement: "right",
		classes: "left-[25%] bottom-[9%]",
		link: "/shop/candles/9"
	},
	{
		id: 10,
		placement: "right",
		classes: "left-[33%] top-[20%]",
		link: "/shop/toppers/10"
	}
];

const getPriceFromPricePolicy = (product: ShopInteractiveProductResponseDto) => {
	return shopStore.components.pricePolicies.find(pricePolicy => pricePolicy.kind === product.kindId &&
			pricePolicy.materials.includes(product.materialId) &&
			pricePolicy.sizes.includes(product.sizeId));
};

const linkedItems = computed(() => productIdMapping.map(({ id, placement, classes, link }) => {
	const product = shopStore.interactiveProducts.find(product => product.id === id) as ShopInteractiveProductResponseDto;
	if (!product) { return undefined; }

	const pricePolicy = getPriceFromPricePolicy(product);

	return {
		tooltip: {
			title: product.name,
			description: formatCurrency(pricePolicy?.price || 0) as number,
			imageId: product.imageId,
			placement
		},
		classes,
		link
	};
}).filter(Boolean)
);
</script>

<template>
	<section
		class="bg-gray relative flex justify-center m-auto rounded-xs w-[1181px] h-[700px]"
	>
		<NuxtImg
			src="img/interactive-image.webp"
			width="1181"
			height="700"
			loading="lazy"
			alt="image"
		/>
		<!-- <h1 class="mt-11 uppercase text-3xl font-medium">
			Collection
		</h1> -->
		<div>
			<HomeCollectionButton
				v-for="(item, i) in linkedItems"
				:key="i"
				class="absolute"
				:class="item.classes"
				:tooltip="item.tooltip"
				@click="navigateTo(item.link)"
			/>
		</div>
	</section>
</template>

<style>
	.custom {
		transition: all 500ms ease;
	}
</style>
